import { type SetStateAction, useCallback, useRef, useState } from 'react';

const EMPTY_DELAY = 0;
const DEFAULT_DELAY_MS = EMPTY_DELAY;

export function useStateWithDelay<S>(
  initialState: InitialState<S>,
  defaultDelayMs = DEFAULT_DELAY_MS
): [S, DispathWithDelay<S>] {
  const [state, setState] = useState<S>(initialState);
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  const setStateWithDelay = useCallback<DispathWithDelay<S>>(
    (nextValue, delayMs = defaultDelayMs) => {
      clearTimeout(timeout.current);

      if (delayMs === EMPTY_DELAY) {
        setState(nextValue);

        return;
      }

      timeout.current = setTimeout(setState, delayMs, nextValue);
    },
    [defaultDelayMs]
  );

  return [state, setStateWithDelay];
}

export type InitialState<S> = S | (() => S);

export type DispathWithDelay<S> = (
  value: SetStateAction<S>,
  delayMs?: number
) => void;
